<div class="loader-container" *ngIf="isLoading">
  <img src="assets/banpara-logo-branca.svg" alt="banpara-logo" />
  <div class="dot-pulse"></div>
</div>
